module.exports = __webpack_public_path__ + "img/Group17.335d3e22.jpg";